export { SectionWrapper, type SectionWrapperProps } from "./SectionWrapper";
